export enum TaskType {
  Meeting = 'meeting',
  Task = 'task',
  Post = 'post',
  RoadBlog = 'roadBlog',
}
